import { render } from "./VueStatusBadge.vue?vue&type=template&id=7f70669b&scoped=true&ts=true"
import script from "./VueStatusBadge.vue?vue&type=script&lang=ts"
export * from "./VueStatusBadge.vue?vue&type=script&lang=ts"

import "./VueStatusBadge.vue?vue&type=style&index=0&id=7f70669b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f70669b"]])

export default __exports__